import React from 'react';
import styled from 'styled-components';
import { Grid, Paper, Typography, Card, Button } from '@material-ui/core';
import { ImageList, ImageListItem } from '@material-ui/core';
import { Link } from 'react-router-dom';
import DoneIcon from '@material-ui/icons/Done';

import Redirector from './Redirector';
import DigimagiAppBar from './DigimagiAppBar';

const WrapperGrid = styled(Grid)`
  padding: 60px 40px 24px;
  height: inherit;
`
const ChangePlanScenePaper = styled(Paper)`
  height: max(100%, 100vh);
`
const PlanCard = styled(Card)`
  display: flex;
  border: solid 1px black;
  height: 160px;
  width: 152px;
  justify-content: center;
  align-items: center;
`
const SelectedIcon = styled(DoneIcon)`
  font-size: 72px;
  color: grey;
`
const PlainLink = styled(Link)`
  text-decoration: none;
`
const BlueButton = styled(Button)`
  font-size: 20px;
`

type ChangePlanSceneProps = {
  redirected: boolean;
  setRedirected: (value: boolean) => void;
}
const ChangePlanScene: React.FC<ChangePlanSceneProps> = ({ redirected, setRedirected }) => {
  const plans = [
    {name: 'プランA', selected: true},
    {name: 'プランB'},
    {name: 'プランC'},
    {name: 'プランD'}
  ];

  if (!redirected) return <Redirector doneRedirect={() => setRedirected(true)} />;
  else return (
    <>
      <DigimagiAppBar setRedirected={setRedirected} parent='UserSettings' />
      <Grid container>
        <Grid item>
        </Grid>
        <Grid item container>
          <Grid item md={12}>
            <ChangePlanScenePaper square>
              <WrapperGrid container>
                <Grid item xs={12}>
                  <ImageList rowHeight="auto" cols={4}>
                    { plans.map((plan) => (
                      <ImageListItem key={plan.name} cols={1}>
                        <PlanCard>
                          <Typography variant="h6">
                            {plan.name}
                            <br />
                            { plan.selected === true && <SelectedIcon /> }
                          </Typography>
                        </PlanCard>
                      </ImageListItem>
                    )) }
                  </ImageList>
                </Grid>
                <Grid item xs={12}>
                  <PlainLink to='deleteAccount'>
                    <BlueButton color='primary'>解約する</BlueButton>
                  </PlainLink>
                </Grid>
                <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <PlainLink to="userSettings">
                      <Button color='primary'>キャンセル</Button>
                    </PlainLink>
                  </Grid>
                  <Grid item>
                    <Button color='primary'>決定する</Button>
                  </Grid>
                </Grid>
              </WrapperGrid>
            </ChangePlanScenePaper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ChangePlanScene;
